module.exports = __webpack_public_path__ + "img/ic_hotel_delete.1343976c.svg";